import styles from './PublicSimplePage.scss';

import React from 'react';

import { Helmet } from 'react-helmet';
import { ContentType } from 'src/api/contentful/contentTypes.public';
import { AutoContentfulEntry } from 'src/components/EntryLoader/AutoContentfulEntry';
import { Environment } from 'src/utils/Environment';
import { PageWrapper } from './PageWrapper';

type PublicSimplePageProps = {
  entryId: string;
  title?: string;
};

export const PublicSimplePage: React.FC<PublicSimplePageProps> = ({ entryId, title }) => (
  <div className={styles.wrapper}>
    <div className={styles.page}>
      <Helmet>
        {title && <title>{title} | Clover</title>}
      </Helmet>
      <AutoContentfulEntry contentType={ContentType.PAGE_SIMPLE} config={Environment.getPublicContentfulConfig()} entryId={entryId}>
        {
          entry => <PageWrapper className={styles.column} entry={entry} />
        }
      </AutoContentfulEntry>
    </div>
  </div>
);
